<template>
  <v-container>
    <h1 class="my-2">Facturas Por Pagar</h1>
    <v-row class="ma-0">
      <v-col cols="12" md="12" class="d-flex my-2 justify-end py-0 px-0">
        <div class="d-flex align-center" style="width: fit-content; background: #BFD7ED; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15); border-radius: 10px; padding: 15px; border: 1px solid #C5CDD3;">
          <div class="pa-1 mr-3" style="background-color: #ECF6FF; border-radius: 5px;">
            <v-img src="../../assets/icons/trending-up.svg" style="width: 24px;"></v-img>
          </div>
          <div class="mr-1" style="font-family: 'montserrat-semibold';">{{ "Total currency gain: " }}</div>
          <span style="font-family: 'montserrat-bold'" :style="{ color: totalProfit < 0 ? '#0075B8' : '#0075B8'}"> 
            {{ " $" + formatMoney(totalProfit) + " " + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN') }}
          </span>
        </div>
      </v-col>
      <v-row class="ma-0" style="width: 100%;">
        <v-col class="pa-0 my-4">
          <v-text-field
            v-model="busqueda"
            placeholder="Buscar"
            clearable
            hide-details
            outlined
            style="width: 280px; font-family: 'montserrat-medium'; border-radius: 20px;"
            prepend-inner-icon="mdi-magnify"
          />
        </v-col>
        <v-col style="display: flex; justify-content: flex-end; align-items: center;" class="pa-0 my-4">
          <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXInvoices()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-col class="pa-0 mb-4" cols="3">
        <v-autocomplete
          :label="'Selecciona un status'"
          :items="status"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          clearable
          class="mr-2"
          color="black"
          item-value="sStatusId"
          item-text="sName"
          @change="getInvoices()"
          v-model="selectedStatus"
        ></v-autocomplete>
      </v-col>
      <v-col class="pa-0 mb-4" cols="3">
        <v-autocomplete
          :label="'Selecciona un beneficiario'"
          :items="paymentsRecipients"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          clearable
          color="black"
          class="mr-2"
          item-value="sPaymentRecipientId"
          item-text="sName"
          @change="getInvoices()"
          v-model="selectedSupplier"
        ></v-autocomplete>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2 mr-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
          @click="dialogCreateInvoice = true"
          :disabled="!permissionList.includes('createInvoice') || loading"          
        >
          {{ "Create invoice" }}
        </v-btn>
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2 mr-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
          @click="dialogConvertInvoices = true"
          :disabled="!permissionList.includes('convertInvoices') || loading"
        >
          {{ "Convert invoice" }}
        </v-btn>
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
          @click="dialogPayInvoices = true, selectedStatus == '904a91ab-bdfc-45dc-a72f-fc02c2a15005' ? (selectedCurrency = selectedDestCurrency, e1 = 2, openPayNow(selectedInvoice)) : e1 = 1"
          :disabled="!permissionList.includes('payInvoices')" 
        >
          {{ "Pay Invoice" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table class="d-none d-sm-block" :items-per-page="5" hide-default-header style="background-color: white !important" :items="filteredInvoices">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr> 
            <th v-if="selectedStatus != 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="header__title left" >{{ '' }}</th> 
            <th class="header__title center">{{ "Beneficiario" }}</th>                                                                                                                                                                                                                                                                                                                                                    
            <th class="header__title center">{{ "Fecha de compra" }}</th>                                                                                                                                                                       
            <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
            <th class="header__title center">{{ "Factura" }}</th>                                                                                                                                                                                                                          
            <th class="header__title center">{{ "Orden de compra" }}</th>
            <th class="header__title center">{{ "Estatus" }}</th>
            <th class="header__title center">{{ "Monto total" }}</th>
            <th class="header__title center">{{ "Tipo de cambio protegido" }}</th>
            <th class="header__title center">{{ "Currency gain" }}</th>
            <th class="header__title center">{{ "Profit (%)" }}</th>
            <th class="header__title right">{{ "Acciones" }}</th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item" v-if="selectedStatus != 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'">
              <v-checkbox
                v-if="selectedStatus == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                :input-value="isSelected(item)"
                color="black"
                @change="toggleSelect(item)"
                :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5' || (selectedDestCurrency !== null && selectedDestCurrency !== item.paymentsRecipent[0].sAccountCurrency)"
              ></v-checkbox>
              <v-checkbox
                color="black"
                v-else-if="selectedStatus == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                :input-value="isSelected(item)"
                @change="toggleSelect(item)"
              ></v-checkbox>
            </td>
            <td class="table__item">{{ item.paymentsRecipent[0].sName }}</td>
            <td class="table__item">{{ formatDate(item.dPurchaseDate) }}</td>
            <td class="table__item">{{ formatDate(item.dDueDate) }}</td>
            <td class="table__item">{{ item.sInvoice }}</td>
            <td class="table__item">{{ item.sId }}</td>
            <td class="table__item">
              <v-chip v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'" class="ma-2" color="black" outlined>
                {{ "To pay" }}
              </v-chip>
              <v-chip v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'" class="ma-2" outlined color="black">
                {{ "Assigned" }}
              </v-chip>
              <v-chip v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'" class="ma-2" outlined color="black">
                {{ "Paid" }}
              </v-chip>
            </td>
            <td class="table__item">{{  "$ " + formatMoney(item.dTotalAmount) + " " + item.paymentsRecipent[0].sAccountCurrency }}</td>
            <td class="table__item">{{  "$ " + formatMoney(item.dRateProtection) + " MXN" }}</td>
            <td class="table__item" :style="item.dCurrencyGain == 0 ? 'color: black;' : (item.dCurrencyGain > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dCurrencyGain ? ('$ ' + formatMoney(item.dCurrencyGain) + ' ' + (enterprise.enterprise.sAccountType == 'EFEXUSD' ? 'USD' : 'MXN')) : "-" }}</td>
            <td class="table__item" :style="item.dProfitPercentage == 0 ? 'color: black;' : (item.dProfitPercentage > 0 ? 'color: #4CAF50;' : 'color: #E74C3C;')">{{ item.dProfitPercentage ? formatMoney(item.dProfitPercentage) + "%" : "-" }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Detalle</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialogEditInvoice = true, invoice = item" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialogDeleteInvoice(item)" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-if="dialogCreateInvoice" v-model="dialogCreateInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ 'Agregar factura' }}</span> 
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ 'Add the following information to add a new invoice.' }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form
                ref="formNew"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Invoice *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sInvoice"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Purchase Order'"
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="forms.new.sId"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete
                      :label="'Beneficiary *'" 
                      required
                      style="border-radius: 10px"
                      :items="paymentsRecipients"
                      outlined
                      item-text="sName"
                      return-object
                      v-model="forms.new.sSupplier"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Fecha de compra *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      type="date"
                      v-model="forms.new.dPurchaseDate"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      :label="(forms?.new?.sSupplier?.sAccountCurrency === 'MXN' ? 'Total amount MXN' : 'Total amount USD') + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dTotalAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Dias de credito *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.iCreditPeriod"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Tipo de cambio protegido *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="forms.new.dRateProtection"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>{{'* indicates required field'}}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogCreateInvoice = false, forms.new = { sInvoice: '', sId: '', sSupplier: null, dPurchaseDate: '', dTotalAmount: '', dRateProtection: '', iCreditPeriod: '' }"
          >
            {{ 'Cancelar' }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            :loading="loading"
            @click="createInvoice()"
          > 
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogConvertInvoices" v-model="dialogConvertInvoices" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="black" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Selección de tarjeta -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ 'Selecciona el tipo de conversión' }}</span> 
                </v-card-title>
                <v-card-text class="py-6 pb-0" v-if="!loading">
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" outlined :class="{ 'selected-card': selectedCard === 2 }" @click="selectedCard = 2" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ 'Convierte pago a MXN' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify">{{ "Convierte tus USD a MXN, luego decide cuándo pagar a tu beneficiario" }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 2" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card class="d-flex pa-6" :disabled="true" outlined :class="{ 'selected-card': selectedCard === 3 }" @click="selectedCard = 3" elevation="0" style="align-self: stretch; background: white; border-radius: 10px; border: 1px solid #dddddd; justify-content: space-between; align-items: flex-start; gap: 16px;">
                      <div class="d-flex flex-column" style="flex: 1 1 0; gap: 8px; align-items: flex-start">
                        <div class="subtitle-1 font-weight-bold" style="color: #302e2e; font-size: 24px">{{ 'Pago a Futuro' }}</div>
                        <div class="body-1" style="color: #666565; text-align: justify"> {{isDisabledForward ? 'Los futuros solo se procesan de 9 a.m. a 4 p.m. (CDMX, GMT-6) por horario bancario' : 'Protégete de fluctuaciones cambiarias' }}</div>
                      </div>
                      <v-icon v-if="selectedCard === 3" color="black">mdi-check-circle</v-icon>
                      <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                    </v-card>
                  </v-col>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="dialogConvertInvoices = false, selectedCard = null, e1 = 1, payDetail = {}, selectedInvoice = []"
                  >
                    {{ 'Cancelar' }}
                  </v-btn>
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="openPayNow(selectedInvoice), e1 = 2"
                    :disabled="selectedCard === null"
                  >
                    {{ 'Continuar'}}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <!-- Paso 2: Detalles según selección -->
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ selectedCard === 2 ? 'Detalle de la conversión' : 'Detalle del Futuro' }}</span>
                </v-card-title>
                <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                  <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                    style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                  >
                    <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                      <div>
                        <div style="margin-right: 30px">
                          <v-img v-if="baseCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                          <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                          <div class="usd-balance">{{ baseCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                        ${{ formatMoney(baseCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                      </div>
                    </div>
                  </v-card>
                  <div style="max-width: 200px;">
                    <v-select
                      :label="'Sort exchange rate by'"
                      required
                      outlined
                      v-if="selectedCurrency == selectedDestCurrency"
                      :items="sortTypes"
                      style="border-radius: 10px"
                      v-model="sortType"
                    ></v-select>
                  </div>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <div v-if="selectedCard === 3" class="pt-4 px-4 mb-4" style="display: flex; justify-content: center; background-color: #e5f6fd; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="#2c93d6" style="margin-right: 12px">mdi-alert-octagon-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: #014361">{{ 'Al programar un Futuro tienes que cumplir con las siguientes dos condiciones:' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: #014361" class="mb-0">{{ 'La fecha seleccionada es la fecha en la cual se ejecutará el pago pactado. La carga de fondos debe efectuarse previo al fin del plazo.' }}</p>
                      <v-divider class="my-4"></v-divider>
                      <p style="font-size: 14px; font-weight: 500; color: #014361">{{ 'Tendrás que hacer un depósito del 5% de los fondos totales del Futuro, los cuales serán restados de tu balance origen.' }}</p>
                    </div>
                  </div>
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ 'Factura a convertir' }}</th>
                          <th>{{ 'Nombre del beneficiario' }}</th>
                          <th>{{ 'Número CLABE' }}</th>
                          <th>{{ 'Cantidad a enviar' }}</th>
                          <th>{{ 'El destinatario recibirá' }}</th>
                          <th>{{ 'Tipo de cambio' }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ 'Si el pago no cuenta con los fondos para la fecha indicada' }} {{ 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.' }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de' }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ 'el monto se restará de tu balance origen.' }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="e1 = 1, checkboxModel = false"
                  >
                    {{ 'Regresar' }}
                  </v-btn>
                  <v-btn 
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :disabled="selectedCard == 3 ? !checkboxModel || !allDatesSelected || !allRatesSelected || loadingCalculator : loadingCalculator || baseCurrency == 'USD' ? totalAmountOrigin > parseFloat(balanceUsd) : totalAmountOrigin > parseFloat(balanceMxn)"
                    @click="convertInvoice(), e1 = 3"
                  >
                    {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="3" elevation="0" class="pt-0">
              <v-btn icon @click="getInvoices(), e1 = 1, selectedCard = null, selectedInvoice = [], dialogConvertInvoices = false" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="#2E404E">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingConversion" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando conversion...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193D6E; border-radius: 10px;">
                    {{ "Conversion realizada correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al realizar la conversion!
                  </v-card-title>
                </div>
                <v-card-text class="pt-4 pb-0 px-0">
                  <v-simple-table>
                    <template v-if="loadingCalculator">
                        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
                    </template>
                    <template v-else>
                      <thead>
                        <tr>
                          <th>{{ 'Factura a convertir' }}</th>
                          <th>{{ 'Nombre del beneficiario' }}</th>
                          <th>{{ 'Número CLABE' }}</th>
                          <th>{{ 'Cantidad a origen' }}</th>
                          <th>{{ 'Cantidad a destino' }}</th>
                          <th>{{ 'Tipo de cambio' }}</th>
                          <th v-if="selectedCard === 3">Forward Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ selectedCard == 2 ? formatMoney(invoice.dExchangeRate) : (invoice.dForwardExchangeRate ? formatMoney(invoice.dForwardExchangeRate) : "") }} MXN</td>
                          <td v-if="selectedCard === 3">
                            <v-dialog v-if="dialogConvert" ref="dialog" v-model="invoice.modal" width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn text :color="invoice.dForwardDate ? 'primary' : 'grey'" v-bind="attrs" v-on="on">
                                  {{ invoice.dForwardDate ? formatDate(invoice.dForwardDate) : "Select Date" }}
                                </v-btn>
                              </template>
                              <v-date-picker v-model="invoice.dForwardDate" :min="today" :allowed-dates="onlyWeekdays" :max="limit" scrollable @input="getForwardRate(invoice)">
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="closeDatePicker(invoice)"
                                  >
                                  Cancel
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + (selectedCurrency ? selectedCurrency : baseCurrency)}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div v-if="selectedCard === 3" class="pt-4 px-4 my-4 mt-6" style="display: flex; justify-content: center; background-color: #fff4e5; flex-direction: row; border-radius: 15px;">
                    <div>
                      <v-icon color="rgb(237, 108, 2)" style="margin-right: 12px">mdi-alert-outline</v-icon>
                    </div>
                    <div>
                      <p style="font-size: 16px; font-weight: 700; color: rgb(102, 60, 0)">{{ 'Por favor carga los fondos correspondientes antes o en la fecha del vencimiento' }}</p>
                      <p style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                        {{ 'Si el pago no cuenta con los fondos para la fecha indicada' }} {{ 'En caso de no cumplir con el pago de la operación pactada, se deberá cubrir el diferencial entre la tipo de cambio de esa fecha y la pactada inicialmente.' }}
                      </p>
                      <v-checkbox v-model="checkboxModel" color="primary" hide-details class="pb-5">
                        <template v-slot:label>
                          <div style="font-size: 14px; font-weight: 500; color: rgb(102, 60, 0)">
                            {{ 'Necesitarás disponer el 5% de los fondos totales del Futuro ahora, el monto a depositar es de' }} <span style="font-size: 18px; font-weight: bold;">{{ totalAmountOrigin ? formatMoney(totalAmountOrigin * .5) + ' USD' : 'N/A' }}</span> {{ 'el monto se restará de tu balance origen.' }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </div>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogPayInvoices" v-model="dialogPayInvoices" persistent width="fit-content" class="pa-8">
      <v-card>
        <v-stepper v-model="e1" alt-labels elevation="0">
          <v-stepper-header color="black" v-if="e1 < 3" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="e1 > 1" step="1" color="black"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" color="black"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Paso 1: Detalle de pago -->
            <v-stepper-content step="1" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">
                    {{ 'Selecciona la wallet desde la que desea utilizar los fondos.' }}
                  </span>
                </v-card-title>
                <v-card-text class="py-6 px-4" v-if="!loading" style="display: flex; align-items: center; width: fit-content; margin: auto; gap: 30px; flex-wrap: wrap; justify-content: center;">
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'USD'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">{{ "Wallet USD" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'USD'" color="black">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceUsd ? balanceUsd : 0) }} USD
                    </div>
                  </div>
                </v-card>
                <v-card class="d-flex pa-6" outlined @click="selectedCurrency = 'MXN'" elevation="2"
                  style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                >
                  <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                    <div>
                      <div style="margin-right: 30px">
                        <v-img src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                        <div style="font-family: 'montserrat-bold'; text-wrap: nowrap;">{{ "Wallet MXN" }}</div>
                      </div>
                    </div>
                    <v-icon v-if="selectedCurrency === 'MXN'" color="black">mdi-check-circle</v-icon>
                    <v-icon v-else color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                  <div>
                    <div class="content-balance pt-3" style="font-family: 'montserrat-bold'; text-wrap: nowrap;">
                      ${{ formatMoney(balanceMxn ? balanceMxn : 0) }} MXN
                    </div>
                  </div>
                </v-card>
                </v-card-text>
                <div v-else style="display: flex; justify-content: center">
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </div>
                <v-card-actions class="mt-5" style="justify-content: space-evenly;">
                  <v-btn
                    elevation="4"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    @click="selectedCurrency = null, dialogPayInvoices = false, payDetail = {}, selectedInvoice = []"
                  >
                    {{ 'Cancelar' }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="4343"
                    class="white--text px-10"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    :loading="loading"
                    :disabled="selectedCurrency === null"
                    @click="openPayNow(selectedInvoice), e1 = 2"
                  > 
                    {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2" elevation="0" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack" style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Detalle de pago' }}</span>
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <v-card class="d-flex pa-6 mb-4" outlined elevation="2"
                      style="background: white; border-radius: 10px; border: 1px solid #dddddd; flex-direction: column; justify-content: space-between; width: 300px;"
                    >
                      <div style="display: flex; align-items: flex-start; justify-content: space-between;">
                        <div>
                          <div style="margin-right: 30px">
                            <v-img v-if="selectedCurrency == 'USD'" src="../../assets/images/Flags_usa.svg" alt="mex-flag" width="50" height="30"/>
                            <v-img v-else src="../../assets/images/Flags_mex.svg" alt="mex-flag" width="50" height="30"/>
                            <div style="font-size: 13px; font-family: 'montserrat-bold';">{{ selectedCurrency == 'USD' ? "Wallet USD" : "Wallet MXN" }}</div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="content-balance pt-3" style="font-family: 'montserrat-semibold'; text-wrap: nowrap;">
                          ${{ formatMoney(selectedCurrency == 'USD' ? balanceUsd : balanceMxn) }} {{ selectedCurrency }}
                        </div>
                      </div>
                    </v-card>
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Factura a pagar' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Nombre del beneficiario' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Número CLABE' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Cantidad a enviar' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'El destinatario recibirá' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Tipo de cambio' }}</th>
                        <th style="font-size: 13px; font-family: 'montserrat-bold';">{{ 'Concepto de pago' }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ invoice.sInvoice }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ invoice.supplier }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">{{ "********" + invoice.sAccountNumber }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                          <td style="min-width: 200px;">
                            <v-text-field
                              v-model="invoice.comment"
                              dense
                              hide-details
                              class="pt-0 mt-0"
                              :placeholder="'Pago ' + invoice.sInvoice"
                              style="font-size: 13px; font-family: 'montserrat-bold';"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right" style="font-size: 13px; font-family: 'montserrat-bold';">Total:</td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td style="font-size: 13px; font-family: 'montserrat-bold';">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
                <v-card-actions class="pt-8" style="justify-content: space-evenly;">
                  <v-btn
                    color="black"
                    elevation="8"
                    class="mr-2 px-10"
                    style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                    outlined
                    :disabled="loading"
                    @click="e1 = 1, selectedCurrency = null"
                  >
                    {{ 'Regresar' }}
                  </v-btn>
                  <v-btn
                    color="black"
                    elevation="8"
                    class="white--text px-10"
                    :disabled="loadingCalculator || totalAmountOrigin > parseFloat(selectedCurrency == 'USD' ? balanceUsd : balanceMxn)"
                    style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
                    @click="payInvoice(), e1 = 3"
                  >
                  {{ 'Continuar' }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-stepper-content>

            <v-stepper-content step="3" elevation="0" class="pt-0">
              <v-btn icon @click="getInvoices(), e1 = 1, selectedInvoice = [], dialogPayInvoices = false, selectedCurrency = null, sortType = 'asc'" :disabled="loadingPayment" style="margin-right: 10px; position: absolute; z-index: 8; right: 0; top: 0; margin-top: 10px;">
                <v-icon color="black">mdi-close</v-icon>
              </v-btn>
              <v-container class="mt-1">
                <div v-if="loadingPayment" class="mb-0" style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column; margin: 40px 0;">
                  <v-progress-circular indeterminate color="primary" size="64" width="6" />
                  <p style="margin-top: 16px; font-weight: bold;">Procesando pago...</p>
                </div>
                <div v-if="paymentError === false">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/check.svg" alt="check" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #193d6d; border-radius: 10px;">
                    {{ "Pago procesado correctamente!" }}
                  </v-card-title>
                </div>
                <div v-if="paymentError === true">
                  <div style="width: 100%; display: flex; justify-content: center; margin-bottom: -50px;">
                    <v-img style="border-radius: 10px" src="@/assets/icons/delete.svg" alt="error" max-width="72" height="72"/>
                  </div>
                  <v-card-title class="py-6 my-4 text-center font-weight-bold" style="color: #FFFFFF; display: flex; justify-content: center; background-color: #E31D1C; border-radius: 10px;">
                    ¡Error al procesar el pago!
                  </v-card-title>
                </div>
                <v-card-text class="py-6 pb-0">
                  <div style="display: flex; justify-content: space-between; align-items: flex-end;">
                    <div style="max-width: 200px;">
                      <v-select
                        :label="'Sort exchange rate by'"
                        required
                        disabled
                        outlined
                        v-if="selectedCurrency == selectedDestCurrency"
                        :items="sortTypes"
                        style="border-radius: 10px"
                        v-model="sortType"
                      ></v-select>
                    </div>
                  </div>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th>{{ 'Factura a pagar' }}</th>
                        <th>{{ 'Nombre del beneficiario' }}</th>
                        <th>{{ 'Número CLABE' }}</th>
                        <th>{{ 'Cantidad a enviar' }}</th>
                        <th>{{ 'El destinatario recibirá' }}</th>
                        <th>{{ 'Tipo de cambio' }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="loadingCalculator">
                        <tr v-for="n in 3" :key="n">
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                          <td><v-skeleton-loader type="text"></v-skeleton-loader></td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td class="font-weight-bold">
                            <v-skeleton-loader type="text"></v-skeleton-loader>
                          </td>
                          <td></td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr v-for="(invoice, index) in payDetail.invoices" :key="invoice.sInvoiceId">
                          <td>{{ invoice.sInvoice }}</td>
                          <td>{{ invoice.supplier }}</td>
                          <td>{{ "********" + invoice.sAccountNumber }}</td>
                          <td>${{ formatMoney(invoice.dOriginAmount) + " " + invoice.originCurrency }}</td>
                          <td>${{ formatMoney(invoice.dDestAmount) + " " + invoice.destCurrency }}</td>
                          <td>${{ formatMoney(invoice.dExchangeRate) }} MXN</td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-right font-weight-bold">Total:</td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountOrigin) + " " + selectedCurrency}} </td>
                          <td class="font-weight-bold">${{ formatMoney(totalAmountDest)  + " " + selectedDestCurrency }}</td>
                          <td></td>
                        </tr>
                      </template>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogEditInvoice" v-model="dialogEditInvoice" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center">
          <span style="font-family: 'montserrat-bold'; font-size: 25px;">{{ 'Editar factura' }}</span> 
        </v-card-title>
        <v-card-subtitle class="pb-4 mt-3" style="text-align: center;">
          <span style="font-family: 'montserrat-semibold'; font-size: 15px;">{{ 'Add the following information to edit the invoice.' }}</span>
        </v-card-subtitle>
        <v-card-text class="pb-1">
          <v-container>
            <v-row>
              <v-form
                ref="formEdit"
                style="width: 100%"
                lazy-validation
                v-on:submit.prevent
              >
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Invoice *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="invoice.sInvoice"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Purchase Order'"
                      required
                      style="border-radius: 10px"
                      outlined
                      v-model="invoice.sId"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-autocomplete
                      :label="'Beneficiary *'" 
                      required
                      style="border-radius: 10px"
                      :items="paymentsRecipients"
                      outlined
                      item-text="sName"
                      return-object
                      v-model="invoice.paymentsRecipent[0]"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Fecha de compra *'" 
                      required
                      style="border-radius: 10px"
                      outlined
                      type="date"
                      v-model="invoice.dPurchaseDate"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      :label="(invoice?.sSupplier?.sAccountCurrency === 'MXN' ? 'Total amount MXN' : 'Total amount USD') + '*'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="invoice.dTotalAmount"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Dias de credito *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="invoice.iCreditPeriod"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" class="pb-0">
                    <v-text-field
                      :label="'Tipo de cambio protegido *'" 
                      required
                      outlined
                      style="border-radius: 10px"
                      type="number"
                      v-model="invoice.dRateProtection"
                      :rules="[rules.required]"
                      :disabled="loading"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
          <small>{{'* indicates required field'}}</small>
        </v-card-text>
        <v-card-actions class="py-4 pb-6" style="justify-content: space-evenly;">
          <v-btn
            color="black"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogEditInvoice = false, invoice = {}, getInvoices()"
          >
            {{ 'Cancelar' }}
          </v-btn>
          <v-btn
            color="black"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            :loading="loading"
            @click="updateInvoice()"
          > 
            {{ 'Confirm' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="dialogDelete" v-model="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important;">
            {{ "¿Estás seguro de que deseas eliminar esta factura?" }}
          </v-card-title>
          <v-card-text v-if="!loading" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">{{ "Una vez que eliminas la factura no podras recuperarla." }}</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="red"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-10"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="dialogDelete = false"
          >
            {{ "Cancelar" }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-10"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            @click="deleteInvoice()"
          >
            {{ "Eliminar" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  import moment from "moment";
  export default {
    name: "Facturas",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        isLoading: false,
        loading: false,
        busqueda: '',
        invoicesRaw: [],
        e1: 1,
        invoice: null,
        balanceMxn: "0",
        balanceUsd: "0",
        dialogCreateInvoice: false,
        dialogPayInvoices: false,
        dialogConvertInvoices: false,
        dialogDelete: false,
        dialogEditInvoice: false,
        forms: {
          new: {
            dPurchaseDate: "",
            sPaymentRecipientId: "",
            sInvoice: "",
            sId: "",
            dTotalAmount: "",
            dRateProtection: "",
            iCreditPeriod: "",
          },
          delete: {
            sInvoiceId: "",
          },
        },
        paymentError: null,
        selectedCard: null,
        payDetail: {
          supplier: "",
          totalUSD: "",
          exchangeRate: "",
          dTotalAmount: "",
          sAccountNumber: "",
          exchangeRateToday: "",
          sInvoice: "",
        },
        loadingConversion: false,
        selectedInvoice: [],
        loadingCalculator: false,
        comment: "",
        sortType: "asc",
        sortTypes: [
          { text: "Ascendente", value: "asc" },
          { text: "Descendente", value: "desc" },
        ],
        isDisabledForward: false,
        baseCurrency: "USD",
        currentTime: "",
        currentTimeCdmx: "",
        targetCurrency: "MXN",
        selectedCurrency: null,
        currentDate: null,
        totalProfit: 0,
        currentDateCdmx: null,
        isDisabledWindow: false,
        selectedDestCurrency: null,
        paymentsRecipients: [],
        totalAmountOrigin: 0,
        totalAmountDest: 0,
        loadingPayment: false,
        selectedSupplier: null,
        exchangeRateToday: null,
        baseCurrencyInvoice: null,
        targetCurrencyInvoice: null,
        selectedStatus: "453f47d8-d5ad-4159-be49-b48b0f04caa5",
        status: [
          { sName: "To pay", sStatusId: "453f47d8-d5ad-4159-be49-b48b0f04caa5" },
          { sName: "Converted", sStatusId: "904a91ab-bdfc-45dc-a72f-fc02c2a15005" },
          { sName: "Paid", sStatusId: "f42d5b71-bcc8-4c2c-997a-40ad2da2bc31" },
        ],
        rules: {
          required: (v) => !!v || "El campo es obligatorio",
        },
      }
    },
    watch: {
      activeTab(val) {
        if (val === 'facturas') {
          this.selectedStatus = "453f47d8-d5ad-4159-be49-b48b0f04caa5";
          this.currentDate = moment();
          this.currentDateCdmx = moment().clone().utcOffset("-06:00");
          this.getSuppliers();
          this.getInvoices();
          this.checkTime();
        }
      }
    },
    mounted() {
      if (this.activeTab === 'facturas') {
        this.selectedStatus = "453f47d8-d5ad-4159-be49-b48b0f04caa5";
        this.currentDate = moment();
        this.currentDateCdmx = moment().clone().utcOffset("-06:00");
        this.getSuppliers();
        this.getInvoices();
        this.checkTime();
      }
    },
    computed: {
      filteredInvoices() {
        if (!this.busqueda) return this.invoicesRaw;

        const q = this.busqueda.toLowerCase();

        return this.invoicesRaw.filter((item) => {
          const beneficiary = item?.paymentsRecipent?.[0]?.sName || '-';
          const purchaseDate = item.dPurchaseDate ? this.formatDate(item.dPurchaseDate) : '-';
          const dueDate = item.dDueDate ? this.formatDate(item.dDueDate) : '-';
          const invoiceNumber = item.sInvoice || '-';
          const internalId = item.sId || '-';
          const statusName = this.getInvoiceStatusName(item.sStatusId);

          const totalMxn = `$ ${this.formatMoney(item.dTotalAmount)} MXN`;
          const rateProtection = `$ ${this.formatMoney(item.dRateProtection)} MXN`;

          const isUsd = this.enterprise?.enterprise?.sAccountType === 'EFEXUSD';
          const gainCurrency = isUsd ? 'USD' : 'MXN';
          const currencyGain = item.dCurrencyGain != null
            ? `$ ${this.formatMoney(item.dCurrencyGain)} ${gainCurrency}`
            : '-';

          const profitPct = item.dProfitPercentage != null
            ? `${this.formatMoney(item.dProfitPercentage)}%`
            : '-';

          return (
            String(item.iTrackingId).toLowerCase().includes(q) ||
            beneficiary.toLowerCase().includes(q) ||
            purchaseDate.toLowerCase().includes(q) ||
            dueDate.toLowerCase().includes(q) ||
            invoiceNumber.toLowerCase().includes(q) ||
            internalId.toLowerCase().includes(q) ||
            statusName.toLowerCase().includes(q) ||
            totalMxn.toLowerCase().includes(q) ||
            rateProtection.toLowerCase().includes(q) ||
            currencyGain.toLowerCase().includes(q) ||
            profitPct.toLowerCase().includes(q)
          );
        });
      },
    },
    methods: {
      async getInvoices() {
        this.selectedInvoice = [];
        this.invoicesRaw = [];
        this.totalProfit = 0;
        this.operationType = this.enterprise.enterprise.sOperationType;
        this.exchangeRateToday = this.enterprise.exchangeRate.mxnRate;
        if (this.operationType === "Compra") {
          this.baseCurrencyInvoice = 'MXN';
          this.targetCurrencyInvoice = 'USD';
        } else {
          this.baseCurrencyInvoice = 'USD';
          this.targetCurrencyInvoice = 'MXN';
        }
        const payload = {
          sEnterpriseId: this.enterprise.enterprise.sEnterpriseId,
          sPaymentRecipientId: this.selectedSupplier,
          sStatusId: this.selectedStatus,
          sCurrency: this.baseCurrencyInvoice,
          des_currency: this.targetCurrencyInvoice,
          exchangeRate: this.exchangeRateToday,
        };
        DB.post(`${URI}/api/v1/en/administrator/client/invoices`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.invoicesRaw = response.data.invoices;
            this.invoicesRaw.forEach((invoice) => {
              this.totalProfit += parseFloat(invoice.dCurrencyGain);
            });
            this.balanceMxn = response.data.balance.balanceMxn.balance;
            this.balanceUsd = response.data.balance.balanceUsd.balance;
          })
          .catch((error) => {
            this.isLoadingSuppliers = false;
            this.mixError(error, 400);
          });
      },
      getSuppliers() {
        this.isLoadingSuppliers = true;
        const payload = {
          sEnterpriseId: this.enterprise.enterprise.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/suppliers`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.isLoadingSuppliers = false;
            this.paymentsRecipients = response.data.paymentRecipients;
          })
          .catch((error) => {
            this.isLoadingSuppliers = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      },
      async toggleSelect(item) {
        const alreadySelected = this.isSelected(item);
        const destCurrency = item.paymentsRecipent[0].sAccountCurrency;

        if (alreadySelected) {
          this.selectedInvoice = this.selectedInvoice.filter(
            (selectedItem) => selectedItem.sInvoiceId !== item.sInvoiceId
          );

          if (this.selectedInvoice.length === 0) {
            this.selectedDestCurrency = null;
          }

          return;
        }

        if (this.selectedInvoice.length === 0) {
          this.selectedDestCurrency = destCurrency;
          this.selectedInvoice.push(item);
          return;
        }

        if (this.selectedInvoice.length >= 20) {
          this.mixWarning("Solo puedes seleccionar hasta 20 facturas.");
          return;
        }

        if (this.selectedDestCurrency !== destCurrency) {
          this.mixWarning("Solo puedes seleccionar facturas con la misma moneda destino.");
          return;
        }

        this.selectedInvoice.push(item);
      },
      isSelected(item) {
        return this.selectedInvoice.some(
          (selectedItem) => selectedItem.sInvoiceId === item.sInvoiceId
        );
      },
      createInvoice() {
        if (this.$refs.formNew.validate()) {
          this.loading = true;
          let payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            dPurchaseDate: this.forms.new.dPurchaseDate,
            sPaymentRecipientId: this.forms.new.sSupplier.sPaymentRecipientId,
            sInvoice: this.forms.new.sInvoice,
            sId: this.forms.new.sId,
            dTotalAmount: this.forms.new.dTotalAmount,
            dRateProtection: this.forms.new.dRateProtection,
            iCreditPeriod: this.forms.new.iCreditPeriod,
            contactData: {
              create: false,
            },
          };

          DB.post(`${URI}/api/v1/en/administrator/createInvoice`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
            .then((response) => {
              this.loading = false;
              this.mixSuccess(response.data.message);
              this.getInvoices();
              this.dialogCreateInvoice = false;
            })
            .catch((error) => {
              this.loading = false;
              this.mixError(error.response.data.message, error.response.status);
            });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      checkTime() {
        this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
        this.currentTimeCdmx = this.currentDateCdmx.format("MMMM DD, YYYY, HH:mm:ss [GMT-6]");
        const currentHourCdmx = this.currentDateCdmx.hour();
        const currentDayCdmx = this.currentDateCdmx.day();
        if (currentDayCdmx === 6 || currentDayCdmx === 0) {
          this.isDisabledForward = true;
        } else if (currentHourCdmx >= 9 && currentHourCdmx < 16) {
          this.isDisabledForward = false;
        } else {
          this.isDisabledForward = true;
        }
        if (currentDayCdmx === 6 || currentDayCdmx === 0) {
          this.isDisabledWindow = true;
        }
      },
      async openPayNow(items) {
        this.loadingCalculator = true;
        this.totalAmountOrigin = 0;
        this.totalAmountDest = 0;

        const originCurrency = this.selectedCurrency ? this.selectedCurrency : this.baseCurrency;

        this.payDetail.invoices = await Promise.all(items.map(async (item) => {
          const destCurrency = item.paymentsRecipent[0].sAccountCurrency;
          let dOriginAmount = item.dTotalAmount;
          let sExchangeRateReference = null;
          let exchangeRateToday = null;

          if (originCurrency !== destCurrency) {
            const payload = {
              sEnterpriseId: this.$route.params.sEnterpriseId,
              currency: originCurrency,
              desCurrency: destCurrency,
            };

            const response = await DB.post(`${URI}/api/v1/en/administrator/getExchangeRate`, payload, {
              headers: {
                Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
              }
            });
            exchangeRateToday = response.data.exchangeRateToday;
            sExchangeRateReference = response.data.exchangeRateTodayReference;
            dOriginAmount = await this.calculatorAmountInvoice(item.dTotalAmount, sExchangeRateReference);
          }

          return {
            sInvoiceId: item.sInvoiceId,
            supplier: item.sName,
            sInvoice: item.sInvoice,
            dExchangeRate: exchangeRateToday,
            sAccountNumber: (item.paymentsRecipent[0].accountNumber ? item.paymentsRecipent[0].accountNumber.slice(-4) : item.paymentsRecipent[0].sAccountNumber.slice(-4)),
            dOriginAmount,
            dDestAmount: item.dTotalAmount,
            sExchangeRateReference,
            originCurrency,
            destCurrency,
            sPaymentRecipientId: item.sPaymentRecipientId,
            reverse: originCurrency !== destCurrency
          };
        }));

        // Calcular totales
        this.totalAmountOrigin = Math.ceil(
          this.payDetail.invoices.reduce((sum, invoice) => sum + parseFloat(invoice.dOriginAmount), 0) * 100
        ) / 100;

        this.totalAmountDest = this.payDetail.invoices.reduce(
          (sum, invoice) => sum + parseFloat(invoice.dDestAmount),
          0
        );

        this.loadingCalculator = false;
      },
      async calculatorAmountInvoice(amount, rate) {
        const headers = {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        }
        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/calculatorAmount`, {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            amount: amount,
            rate: rate,
            reverse: true
          }, { headers });
          return this.roundHalfEven(response.data.data.result, 2).toFixed(2);
        } catch (error) {
          return null;
        }
      },
      roundHalfEven(num, decimals = 2) {
        const factor = Math.pow(10, decimals);
        const temp = num * factor;
        const floor = Math.floor(temp);
        const diff = temp - floor;

        if (diff === 0.5) {
          return (floor % 2 === 0 ? floor : floor + 1) / factor;
        }

        return Math.round(temp) / factor;
      },
      async convertInvoice() {
        this.loadingConversion = true;
        this.paymentError = null
        
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          invoices: this.payDetail.invoices.map(invoice => ({
            sInvoiceId: invoice.sInvoiceId,
            sInvoice: invoice.sInvoice,
            dOriginAmount: invoice.dOriginAmount,
            dDestAmount: invoice.dDestAmount,
            dExchangeRate: invoice.dExchangeRate,
            sPaymentRecipientId: invoice.sPaymentRecipientId,
            originCurrency: invoice.originCurrency,
            destCurrency: invoice.destCurrency,
            sExchangeRateReference: invoice.sExchangeRateReference,
            reverse: invoice.reverse
          })),
          sTransactionType: this.selectedCard === 2 ? 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' : 'b80e8dc6-4138-449e-8903-968efb8437b3',
          dOriginCurrency: this.baseCurrency,
          dDestCurrency: this.targetCurrency
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/convertInvoices`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          });

          this.mixSuccess(response.data.message, response.data.status);
          this.$emit('wallets:update');
          this.paymentError = false
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
          this.paymentError = true
        } finally {
          this.loadingConversion = false;
        }
      },
      async payInvoice() {
        this.loadingPayment = true;
        this.paymentError = null;

        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          invoices: this.payDetail.invoices.map(invoice => ({
            sInvoiceId: invoice.sInvoiceId,
            sInvoice: invoice.sInvoice,
            dOriginAmount: invoice.dOriginAmount,
            dDestAmount: invoice.dDestAmount,
            sPaymentRecipientId: invoice.sPaymentRecipientId,
            originCurrency: invoice.originCurrency,
            destCurrency: invoice.destCurrency,
            sExchangeRateReference: invoice.sExchangeRateReference,
            reverse: invoice.reverse
          })),
          originCurrency: this.selectedCurrency,
          paymentType: 'Spot',
          sortDirection: this.sortType,
        };

        try {
          const response = await DB.post(`${URI}/api/v1/en/administrator/payInvoices`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          });

          this.mixSuccess(response.data.message, response.data.status);
          this.$emit('wallets:update');
          this.paymentError = false;
        } catch (error) {
          this.mixError(error.response.data.message, error.response.status);
          this.paymentError = true
        } finally {
          this.loadingPayment = false;
        }
      },
      getInvoiceStatusName(id) {
        switch (id) {
          case '453f47d8-d5ad-4159-be49-b48b0f04caa5': return 'To pay';
          case '904a91ab-bdfc-45dc-a72f-fc02c2a15005': return 'Assigned';
          case 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31': return 'Paid';
          default: return 'N/A';
        }
      },
      dataXLSXInvoices({ onlyFiltered = false } = {}) {
        try {
          const isUsd = this.enterprise?.enterprise?.sAccountType === 'EFEXUSD';
          const gainCurrency = isUsd ? 'USD' : 'MXN';

          const data = this.filteredInvoices.map((item) => ({
            "Beneficiario": item?.paymentsRecipent?.[0]?.sName || "-",
            "Fecha compra": item.dPurchaseDate ? this.formatDate(item.dPurchaseDate) : "-",
            "Fecha vencimiento": item.dDueDate ? this.formatDate(item.dDueDate) : "-",
            "No. Factura": item.sInvoice || "-",
            "ID interno": item.sId || "-",
            "Estatus": this.getInvoiceStatusName(item.sStatusId),
            "Total (MXN)": `$ ${this.formatMoney(item.dTotalAmount)} MXN`,
            "Protección TC (MXN)": `$ ${this.formatMoney(item.dRateProtection)} MXN`,
            "Ganancia cambiaria": item.dCurrencyGain != null
              ? `$ ${this.formatMoney(item.dCurrencyGain)} ${gainCurrency}`
              : "-",
            "% Ganancia": item.dProfitPercentage != null
              ? `${this.formatMoney(item.dProfitPercentage)}%`
              : "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Facturas");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, `Facturas${onlyFiltered ? '_filtradas' : ''}.xlsx`);

          this.success = true;
          this.msgSuccess = "Descargando facturas";
        } catch (error) {
          console.error("Error al generar XLSX de facturas:", error);
          this.error = true;
          this.codeError = "XLSX_INVOICES_FAILED";
        }
      },
      openDetail(item) {
        this.$router.push({
          name: "InvoiceDetail",
          params: { sInvoiceId: item.sInvoiceId }
        }).catch(() => {});
      },
      updateInvoice() {
        if (this.$refs.formEdit.validate()) {
          this.loading = true;

          let payload = {
            sEnterpriseId: this.$route.params.sEnterpriseId,
            sInvoiceId: this.invoice.sInvoiceId,
            dPurchaseDate: this.invoice.dPurchaseDate,
            sPaymentRecipientId: this.invoice.paymentsRecipent[0].sPaymentRecipientId,
            sInvoice: this.invoice.sInvoice,
            sId: this.invoice.sId,
            dTotalAmount: this.invoice.dTotalAmount,
            dRateProtection: this.invoice.dRateProtection,
            iCreditPeriod: this.invoice.iCreditPeriod,
          };

          DB.put(`${URI}/api/v1/en/administrator/updateInvoice`, payload, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : "",
            },
          })
            .then((response) => {
              this.loading = false;
              this.invoice = {}
              this.dialogEditInvoice = false;
              this.getInvoices();
            })
            .catch((error) => {
              this.loading = false;
              this.mixError(error.response.data.message, error.response.status);
            });
        } else {
          this.error = true;
          this.codeError = "INVALID_INPUT";
        }
      },
      openDialogDeleteInvoice(item) {
        this.dialogDelete = true;
        this.forms.delete.sInvoiceId = item.sInvoiceId;
      },
      deleteInvoice() {
        this.loading = true;

        let payload = {
          sInvoiceId: this.forms.delete.sInvoiceId,
          sEnterpriseId: this.$route.params.sEnterpriseId
        };

        DB.put(`${URI}/api/v1/en/administrator/deleteInvoice`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
        })
          .then((response) => {
            this.loading = false;
            this.getInvoices();
            this.cancel();
          })
          .catch((error) => {
            this.loading = false;
            this.mixError(error.response.data.message, error.response.status);
          });
      },
    }
  };
</script>

<style scoped>
</style>